import { useTranslations } from '@vocab/react';
import { Box, Button, IconAI } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './CareerFeedAIAssistantFAB.css';

export const CareerFeedAIAssistantFAB = ({
  onButtonClick,
  isButtonLoading,
}: {
  onButtonClick: () => void;
  isButtonLoading: boolean;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      position="fixed"
      display="flex"
      gap="large"
      bottom={0}
      left={0}
      width="full"
      justifyContent="center"
      marginBottom="small"
      zIndex="sticky"
      paddingBottom="small"
    >
      <Box className={styles.fab}>
        <Button
          onClick={onButtonClick}
          variant="solid"
          tone="formAccent"
          loading={isButtonLoading}
          icon={<IconAI />}
          size="standard"
        >
          {isButtonLoading ? t('Loading') : t('Want better job matches?')}
        </Button>
      </Box>
    </Box>
  );
};
